<template>
  <div>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="ml-1"
               v-status="'user_edit'"
               dark
               color="#59C3C3"
               x-small
               fab
               tool
               v-bind="attrs"
               v-on="on"
               @click="action(data, 'edit')"
               outlined> <v-icon dark>mdi-pencil</v-icon></v-btn>
      </template>
      <span>ویرایش مشخصات کاربر و تغییر نقش</span>
    </v-tooltip>



    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="ml-1"
               v-status="'user_show'"
               dark
               color="primary"
               x-small
               fab
               v-bind="attrs"
               v-on="on"
               @click="action(data, 'information')"
               outlined> <v-icon dark>mdi-information</v-icon></v-btn>
      </template>
      <span>مشاهده اطلاعات کاربر حقیقی یا حقوقی</span>
    </v-tooltip>



    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="ml-1"
               dark
               v-status="'adminWallet_access'"
               color="#DBAB23"
               x-small
               v-bind="attrs"
               v-on="on"
               fab
               @click="action(data, 'wallet')"
               outlined> <v-icon dark>mdi-wallet</v-icon></v-btn>
      </template>
      <span>کیف پول کاربری</span>
    </v-tooltip>




    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="ml-1"
               v-status="'accountSwitch_access'"
               dark
               color="red"
               x-small
               fab
               v-bind="attrs"
               v-on="on"
               @click="action(data, 'checkout')"
               outlined> <v-icon dark>mdi-login</v-icon></v-btn>
      </template>
      <span>ورود به حساب کاربر</span>
    </v-tooltip>

  </div>
</template>

<script>

    export default {
      props: {
        data:{},
        action:{
          type:Function
        },meta:{
          type:Object
        }
      },


    }
</script>
